<template>
  <div class="c-station-card">
    <div class="c-station-card-header">
      <div class="c-station-card-title">
        {{ title }}
      </div>
      <a-button type="link" @click="toList">
        查看全部
      </a-button>
    </div>
    <div class="c-station-card-content">
      <template v-if="list.length > 0">
        <div
          v-for="item in _list"
          :key="item.messageId"
          class="c-station-card-content-item"
        >
          <div class="c-station-card-content-item-content">
            <div class="c-station-card-content-item-title">{{ item.title }}</div>
            <div v-if="item.content" class="c-station-card-content-item-msg">{{ item.content }}</div>
          </div>
          <div v-if="wide" class="c-station-card-content-item-time">
            <div class="c-station-card-content-item-time-label">收到时间</div>
            <div>{{ item.createdTimeText }}</div>
          </div>
          <template v-if="item.buttonList && item.buttonList[0]">
            <div class="c-station-card-content-item-btn" :title="item.buttonList[0].name" @click="clickBellItem(item)">
              {{ item.buttonList[0].name }}
            </div>
          </template>
        </div>
      </template>
      <div v-else class="c-station-card-content-empty">
        <img src="~@/assets/images/workbench/no-data.svg" class="c-station-card-content-empty-image" />
        <div class="c-station-card-content-empty-text">{{ emptyText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
export default {
  props: {
    type: {
      type: String,
      default: ''
    },
    wide: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    ...mapState('station', [
      'stationSummaryResult'
    ]),
    title() {
      return this.type === 'task' ? '最新待办' : '最新通知'
    },
    emptyText() {
      return this.type === 'task' ? '暂无未处理事项，点击查看全部可查看全部事项' : '暂无未读消息，点击查看全部可查看全部消息'
    },
    list() {
      return this.type === 'task' ? this.stationSummaryResult.taskList || [] : this.stationSummaryResult.noticeList || []
    },
    _list() {
      return this.list.slice(0, this.wide ? 3 : 2)
    }
  },
  methods: {
    ...mapActions('station', ['stationTaskGo']),
    toList() {
      this.$emit('to-list')
    },
    async clickBellItem(item) {
      this.stationTaskGo({
        bId: item.buttonList[0].id,
        mId: item.messageId
      })
    },
  }
}
</script>

<style lang="scss">
.c-station-card {
  background: #ffffff;
  padding: 16px 16px 0;
  border-radius: 4px;
  box-shadow: 0 0 5px #dddddd;
  .c-station-card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 16px;
    border-bottom: 2px solid #f7f8fa;
    .c-station-card-title {
      font-size: 16px;
      color: #333;
      font-weight: bold;
    }
  }
  .c-station-card-content {
    font-size: 0.14rem;
    .c-station-card-content-item {
      padding: 16px 16px 16px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .c-station-card-content-item-content {
        width: 60%;
      }
      .c-station-card-content-item-time {
        width: 10%;
        min-width: 140px;
        .c-station-card-content-item-time-label {
          margin-bottom: 5px;
        }
      }
      .c-station-card-content-item-btn {
        margin-left: 10px;
        min-width: 80px;
        max-width: 120px;
        overflow: hidden;
        text-overflow: ellipsis;
        border: 1px solid rgb(24, 144, 255);
        height: 32px;
        font-size: 14px;
        color: rgb(24, 144, 255);
        line-height: 30px;
        border-radius: 4px;
        text-align: center;
        cursor: pointer;
        white-space: nowrap;
        padding: 0 4px;
      }
      .c-station-card-content-item-btn:hover, .c-station-card-content-item-btn:focus, .c-station-card-content-item-btn:active {
        color: #409eff;
        background: #ecf5ff;
        border-color: #b3d8ff;
      }
      .c-station-card-content-item-title, .c-station-card-content-item-msg {
        overflow : hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        word-break: break-all;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
      }
      .c-station-card-content-item-title {
        color: #333;
      }
      .c-station-card-content-item-title+.c-station-card-content-item-msg {
        margin-top: 10px;
      }
      .c-station-card-content-item-msg, .c-station-card-content-item-time {
        color: #7f7f7f;
      }
    }
    .c-station-card-content-item+.c-station-card-content-item {
      border-top: 2px solid #f7f8fa;
    }
  }
  .c-station-card-content-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .c-station-card-content-empty-image {
      padding-top: 16px;
      width: 100px;
    }
    .c-station-card-content-empty-text {
      position: relative;
      top: -10px;
      color: #7f7f7f;
      padding-bottom: 16px;
    }
  }
}
</style>
